import { lazy } from 'react';

// ----------------------------------------------------------------------

const FinancesPage = lazy(() => import('../pages/Finances.page'));

// ----------------------------------------------------------------------

const FinancesRoutes = [
    {
        path: '/finances',
        element: <FinancesPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { FinancesRoutes };
